var _style, _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEventopiaLogoBlackText2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2666 498.6",
    style: {
      enableBackground: "new 0 0 2666 498.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;fill:#242424;}\n\t.st1{display:none;}\n\t.st2{display:inline;fill:#854DFF;}\n\t.st3{display:inline;fill:#7A4AFF;}\n\t.st4{display:inline;fill:#FFFFFF;}\n\t.st5{fill:url(#path26_3_);}\n\t.st6{fill:url(#path28_3_);}\n\t.st7{fill:url(#path30_3_);}\n\t.st8{fill:url(#path32_3_);}\n\t.st9{fill:url(#path34_3_);}\n\t.st10{fill:url(#path36_3_);}\n\t.st11{fill:url(#SVGID_1_);}\n\t.st12{fill:url(#path40_3_);}\n\t.st13{fill:url(#path42_3_);}\n\t.st14{fill:url(#path44_3_);}\n\t.st15{fill:url(#path46_3_);}\n\t.st16{fill:url(#path48_3_);}\n\t.st17{fill:url(#SVGID_2_);}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    className: "st0",
    width: 2665.6,
    height: 498.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path26_1_",
    className: "st2",
    d: "M392,434.8c0,10.1-8.2,18.3-18.3,18.3H47.1c-10.1,0-18.3-8.2-18.3-18.3V153.7H392V434.8z  M386.5,59.4h-46.9v18.8c0,18.3-14.9,33.1-33.1,33.1c-18.3,0-33.1-14.9-33.1-33.1V59.4h-123v18.8c0,19.1-16.3,34.5-35.7,33 c-17.3-1.3-30.6-16-30.6-33.4V59.4H37.3C17.2,59.4,1,75.7,1,95.7v349.2c0,20,16.3,36.3,36.3,36.3h349.2c20,0,36.3-16.2,36.3-36.3 V95.7C422.8,75.7,406.6,59.4,386.5,59.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28_1_",
    className: "st2",
    d: "M66.4,252.7h71.8c2.4,0,4.4-2,4.4-4.4V200c0-2.4-2-4.4-4.4-4.4H66.4c-2.4,0-4.4,2-4.4,4.4 v48.3C62.1,250.8,64,252.7,66.4,252.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30_1_",
    className: "st2",
    d: "M174.4,252.7h71.7c2.4,0,4.4-2,4.4-4.4V200c0-2.4-2-4.4-4.4-4.4h-71.7c-2.4,0-4.4,2-4.4,4.4 v48.3C170,250.8,172,252.7,174.4,252.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32_1_",
    className: "st2",
    d: "M282.6,253.4h71.7c2.4,0,4.4-2,4.4-4.4v-48.3c0-2.4-2-4.4-4.4-4.4h-71.7c-2.4,0-4.4,2-4.4,4.4 V249C278.3,251.4,280.3,253.4,282.6,253.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34_1_",
    className: "st2",
    d: "M66.4,332h71.7c2.4,0,4.4-2,4.4-4.4v-48.3c0-2.4-2-4.4-4.4-4.4H66.4c-2.4,0-4.4,2-4.4,4.4 v48.2C62.1,330.1,64,332,66.4,332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36_1_",
    className: "st2",
    d: "M174.4,332.7h71.7c2.4,0,4.4-2,4.4-4.4V280c0-2.4-2-4.4-4.4-4.4h-71.7c-2.4,0-4.4,2-4.4,4.4 v48.2C170,330.8,172,332.7,174.4,332.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M354.4,274.7h-71.7c-2.4,0-4.4,2-4.4,4.4v48.2c0,2.4,1.9,4.4,4.3,4.4h71.7c2.4,0,4.4-2,4.4-4.4V279 C358.8,276.7,356.8,274.7,354.4,274.7z M348,292.8l-36.8,25.3l0,0l-6.9,4.7c-0.6,0.4-1.4,0.2-1.8-0.3l-4.7-6.8l-9.2-13.3 c-0.3-0.5-0.2-1.1,0.3-1.5l7.1-4.9c0.5-0.3,1.1-0.2,1.5,0.3l8.5,12.3l36-24.6c0.6-0.4,1.4-0.3,1.8,0.3l4.6,6.7 C348.8,291.6,348.6,292.4,348,292.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40_1_",
    className: "st2",
    d: "M66.4,411.7h71.7c2.4,0,4.4-2,4.4-4.4V359c0-2.4-2-4.4-4.4-4.4H66.4c-2.4,0-4.4,2-4.4,4.4 v48.2C62.1,409.8,64,411.7,66.4,411.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42_1_",
    className: "st2",
    d: "M174.4,411.7h71.7c2.4,0,4.4-2,4.4-4.4V359c0-2.4-2-4.4-4.4-4.4h-71.7c-2.4,0-4.4,2-4.4,4.4 v48.2C170,409.8,172,411.7,174.4,411.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44_1_",
    className: "st2",
    d: "M282.6,411.7h71.7c2.4,0,4.4-2,4.4-4.4V359c0-2.4-2-4.4-4.4-4.4h-71.7c-2.4,0-4.4,2-4.4,4.4 v48.2C278.3,409.8,280.3,411.7,282.6,411.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46_1_",
    className: "st3",
    d: "M117.2,98.8c11.4,0,20.7-9.3,20.7-20.7V38.8c0-5.7-2.3-10.9-6.1-14.6 c-3.7-3.7-8.9-6.1-14.6-6.1c-11.5,0-20.7,9.5-20.7,21v39C96.5,89.6,105.8,98.8,117.2,98.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48_1_",
    className: "st3",
    d: "M306.5,98.8c11.4,0,20.7-9.3,20.7-20.7V38.8c0-5.7-2.3-10.9-6.1-14.6 c-3.8-3.7-8.9-6.1-14.6-6.1c-11.4,0-20.7,9.3-20.7,20.7v39.3C285.8,89.6,295.1,98.8,306.5,98.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M304.4,322.8l-0.2,0.1c-0.5,0.3-1.1,0.2-1.5-0.3l-0.1-0.2C303,323.1,303.8,323.2,304.4,322.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M661.9,362.3v50.3H492.8V128.8H662v50.3H545.3v76.4h97.4v47.8h-97.4v59H661.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.7,416.4h-3.4L673.5,131.9l2.1-3h56.5l79.2,181.9l77.9-181.9h55.4l1.5,2.6L811.7,416.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.6,362.3v50.3H970.4V128.8h169.2v50.3H1023v76.4h97.4v47.8H1023v59H1139.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1241,412.6h-52.6V124.9h3.4L1385.4,305V128.8h52.7v287.5h-3.6l-193.6-180L1241,412.6L1241,412.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1619.2,412.6h-52.7v-232h-91.7v-51.8h236.1v51.8h-91.7L1619.2,412.6L1619.2,412.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1864.2,416.4c-41.5,0-75.8-13.8-103-41.4c-27.1-27.8-40.6-62.6-40.6-104.2c0-40.6,13.5-75.1,40.6-103.6 c27.3-28.2,62.2-42.3,104.5-42.3c42.1,0,76.4,14.1,103,42.3c26.6,27.7,39.9,62.1,39.9,103.2c0,40.7-13.5,75.3-40.6,103.8 C1941.1,402.3,1906.5,416.4,1864.2,416.4z M1955.1,270.8c0-27.5-8.5-49.9-25.5-67.3c-17-17.8-38.7-26.7-65-26.7 c-25.7,0-47.3,8.9-64.6,26.7c-17.3,17.6-25.9,40.1-25.9,67.3c0,26.5,8.6,48.7,25.9,66.7s38.8,27,64.6,27c25.6,0,47-9,64.3-27 C1946.4,319.3,1955.1,297,1955.1,270.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2108.2,412.6h-52.6V128.8h100.2c29.2,0,53.4,8.8,72.4,26.3c19.2,17.6,28.7,42.5,28.7,74.7c0,33-10.5,59-31.4,77.9 c-20.5,18.5-45.7,27.8-75.4,27.8h-42v77.1H2108.2z M2147.4,176.8h-39.1v110.6h31.4c19.3,0,34.7-5.1,46.4-15.4s17.5-24.2,17.5-41.9 c0-17.4-5-30.6-15-39.7C2178.5,181.4,2164.8,176.8,2147.4,176.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2353,412.6h-52.7V128.8h52.7V412.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2524.9,124.9h3.4L2665.9,410l-2.1,2.6h-54.1l-20.2-46.1h-127l-20,46.1h-53.1l-1.9-2.6L2524.9,124.9z M2526,222 l-42.2,96.4h84.3L2526,222z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path26_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 442.4134,
    y1: 2050.134,
    x2: -32.7866,
    y2: 1474.1339,
    gradientTransform: "matrix(1 0 0 1 0 -1500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6739"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path26_2_",
    className: "st5",
    d: "M391.4,434.4c0,10.1-8.2,18.3-18.3,18.3H46.4c-10.1,0-18.3-8.2-18.3-18.3V153.3h363.2 L391.4,434.4L391.4,434.4z M385.9,59H339v18.8c0,18.3-14.9,33.1-33.1,33.1c-18.3,0-33.1-14.9-33.1-33.1V59h-123v18.8 c0,19.1-16.3,34.5-35.7,33c-17.3-1.3-30.6-16-30.6-33.4V59H36.6C16.5,59,0.3,75.3,0.3,95.3v349.2c0,20,16.3,36.3,36.3,36.3h349.2 c20,0,36.3-16.2,36.3-36.3V95.3C422.1,75.3,405.9,59,385.9,59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path28_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 399.8816,
    y1: 2085.2227,
    x2: -75.3184,
    y2: 1509.2225,
    gradientTransform: "matrix(1 0 0 1 0 -1500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6739"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path28_2_",
    className: "st6",
    d: "M65.8,252.3h71.8c2.4,0,4.4-2,4.4-4.4v-48.3c0-2.4-2-4.4-4.4-4.4H65.8c-2.4,0-4.4,2-4.4,4.4 v48.3C61.4,250.4,63.3,252.3,65.8,252.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path30_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 464.1233,
    y1: 2032.2233,
    x2: -11.0767,
    y2: 1456.2233,
    gradientTransform: "matrix(1 0 0 1 0 -1500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6739"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path30_2_",
    className: "st7",
    d: "M173.8,252.3h71.7c2.4,0,4.4-2,4.4-4.4v-48.3c0-2.4-2-4.4-4.4-4.4h-71.7c-2.4,0-4.4,2-4.4,4.4 v48.3C169.4,250.4,171.4,252.3,173.8,252.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path32_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 528.1707,
    y1: 1979.3842,
    x2: 52.9707,
    y2: 1403.3842,
    gradientTransform: "matrix(1 0 0 1 0 -1500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6739"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path32_2_",
    className: "st8",
    d: "M282,253h71.7c2.4,0,4.4-2,4.4-4.4v-48.3c0-2.4-2-4.4-4.4-4.4H282c-2.4,0-4.4,2-4.4,4.4v48.3 C277.6,251,279.6,253,282,253"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path34_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 360.8897,
    y1: 2117.3909,
    x2: -114.3103,
    y2: 1541.3911,
    gradientTransform: "matrix(1 0 0 1 0 -1500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6739"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path34_2_",
    className: "st9",
    d: "M65.8,331.6h71.7c2.4,0,4.4-2,4.4-4.4V279c0-2.4-2-4.4-4.4-4.4H65.8c-2.4,0-4.4,2-4.4,4.4v48.2 C61.4,329.8,63.3,331.6,65.8,331.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path36_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 424.8176,
    y1: 2064.6504,
    x2: -50.3824,
    y2: 1488.6504,
    gradientTransform: "matrix(1 0 0 1 0 -1500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6739"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path36_2_",
    className: "st10",
    d: "M173.8,332.4h71.7c2.4,0,4.4-2,4.4-4.4v-48.3c0-2.4-2-4.4-4.4-4.4h-71.7c-2.4,0-4.4,2-4.4,4.4 v48.2C169.4,330.4,171.4,332.4,173.8,332.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 489.6848,
    y1: 2011.135,
    x2: 14.4847,
    y2: 1435.135,
    gradientTransform: "matrix(1 0 0 1 0 -1500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6739"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M353.8,274.4h-71.7c-2.4,0-4.4,2-4.4,4.4V327c0,2.4,1.9,4.4,4.3,4.4h71.7c2.4,0,4.4-2,4.4-4.4v-48.3 C358.1,276.4,356.1,274.4,353.8,274.4z M347.4,292.4l-36.8,25.3l0,0l-6.9,4.7c-0.6,0.4-1.4,0.2-1.8-0.3l-4.7-6.8L288,302 c-0.3-0.5-0.2-1.1,0.3-1.5l7.1-4.9c0.5-0.3,1.1-0.2,1.5,0.3l8.5,12.3l36-24.6c0.6-0.4,1.4-0.3,1.8,0.3l4.6,6.7 C348.1,291.3,348,292,347.4,292.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path40_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 321.7658,
    y1: 2149.6682,
    x2: -153.4342,
    y2: 1573.6682,
    gradientTransform: "matrix(1 0 0 1 0 -1500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6739"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path40_2_",
    className: "st12",
    d: "M65.8,411.4h71.7c2.4,0,4.4-2,4.4-4.4v-48.3c0-2.4-2-4.4-4.4-4.4H65.8c-2.4,0-4.4,2-4.4,4.4 v48.2C61.4,409.4,63.3,411.4,65.8,411.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path42_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 386.0374,
    y1: 2096.644,
    x2: -89.1626,
    y2: 1520.644,
    gradientTransform: "matrix(1 0 0 1 0 -1500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6739"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path42_2_",
    className: "st13",
    d: "M173.8,411.4h71.7c2.4,0,4.4-2,4.4-4.4v-48.3c0-2.4-2-4.4-4.4-4.4h-71.7c-2.4,0-4.4,2-4.4,4.4 v48.2C169.4,409.4,171.4,411.4,173.8,411.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path44_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 450.4182,
    y1: 2043.5299,
    x2: -24.7818,
    y2: 1467.5299,
    gradientTransform: "matrix(1 0 0 1 0 -1500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6739"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path44_2_",
    className: "st14",
    d: "M282,411.4h71.7c2.4,0,4.4-2,4.4-4.4v-48.3c0-2.4-2-4.4-4.4-4.4H282c-2.4,0-4.4,2-4.4,4.4 v48.2C277.6,409.4,279.6,411.4,282,411.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path46_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 490.0424,
    y1: 2010.84,
    x2: 14.8425,
    y2: 1434.84,
    gradientTransform: "matrix(1 0 0 1 0 -1500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6739"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path46_2_",
    className: "st15",
    d: "M116.5,98.4c11.4,0,20.7-9.3,20.7-20.7V38.4c0-5.7-2.3-10.9-6.1-14.6 c-3.7-3.7-8.9-6.1-14.6-6.1c-11.5,0-20.7,9.5-20.7,21v39C95.8,89.2,105.2,98.4,116.5,98.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path48_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 602.7167,
    y1: 1917.8838,
    x2: 127.5167,
    y2: 1341.8838,
    gradientTransform: "matrix(1 0 0 1 0 -1500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6739"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "path48_2_",
    className: "st16",
    d: "M305.9,98.4c11.4,0,20.7-9.3,20.7-20.7V38.4c0-5.7-2.3-10.9-6.1-14.6 c-3.8-3.7-8.9-6.1-14.6-6.1c-11.4,0-20.7,9.3-20.7,20.7v39.3C285.1,89.2,294.5,98.4,305.9,98.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 471.2714,
    y1: 2026.326,
    x2: -3.9286,
    y2: 1450.326,
    gradientTransform: "matrix(1 0 0 1 0 -1500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6739"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M303.8,322.4l-0.2,0.1c-0.5,0.3-1.1,0.2-1.5-0.3L302,322C302.4,322.8,303.1,322.9,303.8,322.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventopiaLogoBlackText2);
export default __webpack_public_path__ + "static/media/Eventopia Logo Black Text2.965156b5f67d1fe36826fab2c9ce3b2e.svg";
export { ForwardRef as ReactComponent };